module.exports = __webpack_public_path__ + "img/flag-01.b02c0059.svg";